import 'select2';
import 'select2/dist/css/select2';
import { Controller } from "stimulus"
import Swal from "sweetalert2";
import CommissionService from '../entrypoints/src/admin/services/commission-service';
import { mountTiptapEditor } from '../entrypoints/src/admin/editor/create_editor';

// Merge-tag variables available inside a dynamic commission expression.
const EXPRESSION_VARIABLES = [
  {
    title: 'Variáveis',
    menu: [
      { value: 'amountStudentInsideClass', title: 'Quantidade de alunos por horário da turma' },
      { value: 'amountMonthClasses', title: 'Quantidade de aulas dentro mês' }
    ]
  }
];

export default class extends Controller {
  static targets = [ 'emptyMessage', 'container', 'calculationsType' ];
  static values = { commissionsSize: Number };

  connect() {
    this.updateEmptyMessage();
    $(this.element).on('change', 'input[type="checkbox"].enabled-commission', (ev) => this.toggleEnableCommissionRow(ev.currentTarget));
    this.element.querySelectorAll('input[type="checkbox"].enabled-commission').forEach(($el) => { this.toggleEnableCommissionRow($el) });
    this.element.querySelector('a.add-row').addEventListener('add-row:appended', (ev) => {
      this.commissionsSizeValue += 1;
      this.bindSelect2([...this.element.querySelectorAll('.commissions .commission-row')].pop().querySelector('select.commissionable'));
    });
    $(this.element).on('change', 'select.calculation-select', (ev) => this.updateCalculationType(ev.currentTarget));
    $(this.element).on('click', '.value-price input[type="text"].evaluate-expression', (ev) => this.openModalText(ev.currentTarget));
    this.element.querySelectorAll('select.calculation-select').forEach(($el) => this.updateCalculationType($el));
    this.bindSelect2('select.commissionable');

    $('#modal-dynamic-textarea').on('hide.bs.modal', () => {
      if (!this.currentInput)
        return;

      // Persist the expression (plain text, so the "{{var}}" tokens survive verbatim).
      if (this.expressionEditor)
        this.currentInput.value = this.expressionEditor.getText();
      this.currentInput = undefined;
    });
    // turbo-frame to swap commission professor
    if (!document.querySelector('#swap-professor-commission'))
      document.body.insertAdjacentHTML('beforeend', '<turbo-frame id="swap-professor-commission"></turbo-frame>');
  }

  toggleEnableCommissionRow($checkbox) {
    let $row = $checkbox.closest('.row');

    $row.querySelectorAll('.calculation-select, .value-cents, .evaluate-expression').forEach(($input) => {
      if ($checkbox.checked)
        return $input.removeAttribute('disabled');

      $input.setAttribute('disabled', 'disabled')
    })
  }

  bindSelect2(selects) {
    $(selects).select2({
      placeholder: '-- selecione --',
      multiple: false,
      allowClear: false,
      escapeMarkup: (markup) => markup
    }).on('select2:select', (ev) => {
      let row = ev.target.closest('.row'),
        commissionalType = row.querySelector('.commissionable-type');

      if (!commissionalType)
        return row.insertAdjacentHTML('afterbegin', `<input value="${ev.currentTarget.selectedOptions[0].dataset.commissionableType}" class="commissionable-type" autocomplete="off" type="hidden" name="${this.element.objectName}[commissionable_type]">`)

      commissionalType.value = ev.currentTarget.selectedOptions[0].dataset.commissionableType;
    });
  }

  updateCalculationType($el) {
    let row = $el.closest('.commission-row'),
      inputValue = row.querySelector('input[type="text"].value-cents'),
      inputExpression = row.querySelector('input[type="text"].evaluate-expression');
    if (!$el.selectedOptions[0].dataset.calculationType)
      return;

    row.querySelector('.calculation-type').innerHTML = $el.selectedOptions[0].dataset.calculationType;
    inputValue.classList.toggle('d-none', $el.value == 'dynamic');
    inputExpression.classList.toggle('d-none', $el.value != 'dynamic');
  }

  openModalText($el) {
    const row = $el.closest('.commission-row');
    const select = row.querySelector('.calculation-select');
    this.currentInput = row.querySelector('input[type="text"].evaluate-expression');

    if (select.value !== 'dynamic')
      return;

    this.$modal = document.querySelector('#modal-dynamic-textarea');
    if (!this.$modal)
      return;

    this.ensureExpressionEditor();
    this.setExpression(this.currentInput.value);
    $(this.$modal).modal('show');
  }

  // Mounts the Tiptap expression editor once and reuses it across modal openings.
  // Minimal toolbar: merge tags + a "Validar Expressão" button (opens the values modal).
  ensureExpressionEditor() {
    if (this.expressionEditor)
      return;

    const textarea = document.querySelector('#dynamic-textarea-expression');
    this.expressionEditor = mountTiptapEditor(textarea, {
      variant: 'minimal',
      groups: EXPRESSION_VARIABLES,
      extraButtons: [
        {
          label: 'Validar Expressão',
          title: 'Validar Expressão',
          accent: true,
          onClick: () => $('#modal-validate-expression').modal('show')
        }
      ]
    });
  }

  // Sets the editor content as plain text so expression operators like "<" / ">"
  // are never parsed as HTML.
  setExpression(text) {
    this.expressionEditor.commands.setContent({
      type: 'doc',
      content: [{ type: 'paragraph', content: text ? [{ type: 'text', text }] : [] }]
    });
  }

  async validateExpression(ev) {
    try {
      let response = await CommissionService.validate(this.expressionEditor.getText(), {
        amountStudentInsideClass: document.querySelector('#amount-student-inside-class').value,
        amountMonthClasses: document.querySelector('#amount-month-classes').value
      });

      if (!!response.success)
        return Swal.fire({
          customClass: { confirmButton: 'btn btn-gray-primary mx-2', cancelButton: 'btn btn-danger mx-2' },
          buttonsStyling: false,
          html: `Resultado da expressão: <br> <code class="mt-3 d-block bg-grey px-3 py-2 rounded-lg">${response.success}</code>`,
          animation: false,
          showCancelButton: false,
          confirmButtonText: 'Fechar'
        });

      Swal.fire({
        customClass: { confirmButton: 'btn btn-gray-primary mx-2', cancelButton: 'btn btn-danger mx-2' },
        buttonsStyling: false,
        html: `Ocorreu um erro na validação da expressão.<br> <code class="mt-3 d-block bg-grey px-3 py-2 rounded-lg">${response.error}</code>`,
        type: 'error',
        animation: false,
        showCancelButton: false,
        confirmButtonText: 'Fechar'
      });
    } catch (ex) {
      Swal.fire({
        customClass: { confirmButton: 'btn btn-gray-primary mx-2', cancelButton: 'btn btn-danger mx-2' },
        buttonsStyling: false,
        title: 'Atenção',
        text: "Não foi possível validar a expressão nesse momento",
        type: 'error',
        animation: false,
        showCancelButton: false,
        confirmButtonText: 'Fechar'
      });
    }
  }

  removeCommission(ev) {
    let $row = ev.currentTarget.closest('.row'),
      inputName = $row.dataset.inputName;
    this.askConfirmation().then((result) => {
      if (result.value) {
        this.containerTarget.insertAdjacentHTML('beforeend', `<input type="hidden" name="${inputName}[_destroy]" value="1" />`);
        this.containerTarget.insertAdjacentHTML('beforeend', `<input type="hidden" name="${inputName}[id]" value="${$row.dataset.id}" />`);
        $row.remove();
        this.commissionsSizeValue -= 1;
        return;
      }
    });
  }

  toggleContainer(ev) {
    let container = ev.currentTarget.dataset.container;
    document.querySelector(container).classList.toggle('hidden');
  }

  askConfirmation() {
    return Swal.fire({
      customClass: {
        cancelButton: 'btn btn-gray-primary mx-2',
        confirmButton: 'btn btn-danger mx-2'
      },
      buttonsStyling: false,
      title: 'Atenção',
      text: "Tem certeza que deseja remover esse professor?",
      type: 'warning',
      animation: false,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, tenho certeza'
    });
  }

  commissionsSizeValueChanged() {
    this.updateEmptyMessage();
  }

  updateEmptyMessage() {
    this.emptyMessageTarget.classList.toggle('hidden', this.commissionsSizeValue > 0);
    this.containerTarget.classList.toggle('hidden', this.commissionsSizeValue == 0);
  }
}
